import clsx from "clsx"
import { ChangeEvent, useRef } from "react"

interface TextareaProps {
	setValue: (v: string) => void
	placeholder: string
	value: string
	placeholderIcon?: JSX.Element
	maxCount?: number
	background?: string
	onKeyDown?: React.KeyboardEventHandler<HTMLTextAreaElement>
}

export function Textarea(props: TextareaProps) {
	const {
		placeholder,
		placeholderIcon,
		value,
		maxCount,
		background,
		setValue,
		onKeyDown,
	} = props
	const textareaRef = useRef<HTMLTextAreaElement>(null)

	const handleInputChange = (
		e: ChangeEvent<HTMLTextAreaElement>,
	) => {
		const inputValue = e.currentTarget.value
		if (maxCount) {
			if (inputValue.length > maxCount) {
				setValue(inputValue.slice(0, maxCount))
			} else {
				setValue(inputValue)
			}
		} else {
			setValue(inputValue)
		}
	}

	return (
		<div className={clsx("relative h-full w-full")}>
			<textarea
				onKeyDown={onKeyDown}
				value={value}
				onChange={handleInputChange}
				ref={textareaRef}
				className={clsx(
					background ? background : "bg-color-cell",
					"h-full w-full text-blue-800 outline-none",
					"no-scrollbar resize-none",
				)}
			/>
			<div
				onClick={() => textareaRef.current?.focus()}
				className={clsx(
					value === "" ? "flex" : "hidden",
					"absolute left-0 top-0 z-20 [--icon-color:var(--color-blue-600)]",
					"cursor-text items-center gap-[4px] pl-[2px]",
				)}>
				{placeholderIcon && placeholderIcon}
				<span className="text-[16px] font-400 text-color-placeholder">
					{placeholder}
				</span>
			</div>

			{maxCount && (
				<div className="absolute bottom-0 right-[10px] flex gap-[2px]">
					<span className="text-[13px] font-400 text-blue-800">
						{value.length}
					</span>
					<span className="text-[13px] font-400 text-blue-400">
						/ {maxCount}
					</span>
				</div>
			)}
		</div>
	)
}
